module.exports = "/images/vendor/desiigner-svg/svg/logos/unicredit-neg.svg?27b6a2a2d8c21a169af4d35f375e167e";